import { METHOD } from './method'

export const API_USER_ROLE = {
    LIST: {
        api: '/v1/dashboard-admin/roles',
        method: METHOD.GET,
    },
    DELETE: {
        api: '/v1/dashboard-admin/roles',
        method: METHOD.DELETE,
    },
    LIST_PERMISSION: {
        api: '/v1/dashboard-admin/roles/permissions',
        method: METHOD.GET,
    },
    CREATE: {
        api: '/v1/dashboard-admin/roles',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/roles',
        method: METHOD.PUT,
    },
}
